module.exports = __webpack_public_path__ + "img/footer-grid.70176588.png";